<template>
  <div>
    <!-- 标题 -->
    <div class="ApplicationConfiguration-title">
      <Breadcrumb>
        <BreadcrumbItem to="/aiMonitor/operatingSystem">{{
          $t("smartMonitor.applicationSystem.title")
        }}</BreadcrumbItem>
        <BreadcrumbItem>{{
          $t("smartMonitor.applicationSystem.applicationConfig")
        }}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <template>
      <Tabs size="small" :value="currentTab" @on-click="currentTabChanged">
        <TabPane label="实例" name="instance">
          <add-instances></add-instances>
        </TabPane>
        <TabPane label="数据库" name="database">
          <add-databases ref="databaseChild"></add-databases>
        </TabPane>
        <TabPane label="磁盘" name="disk">
          <add-volumes ref="diskChild"></add-volumes>
        </TabPane>
        <TabPane label="Elasticsearch" name="Elasticsearch">
          <add-Elasticsearch ref="ElasticsearchChild"></add-Elasticsearch>
        </TabPane>
      </Tabs>
    </template>
  </div>
</template>

<script>
import AddInstances from "../application_configuration/AddInstances";
import AddDatabases from "../application_configuration/AddDatabases";
import AddVolumes from "@/components/ai_monitor/application_configuration/AddVolumes";
import AddElasticsearch from "@/components/ai_monitor/application_configuration/AddElasticsearch";

export default {
  name: "ApplicationConfiguration",
  components: {
    AddInstances,
    AddDatabases,
    AddVolumes,
    AddElasticsearch
  },
  data() {
    return {
      currentTab: "",
      tabName: "instance"
    };
  },
  mounted: function() {},
  methods: {
    // 根据相应的tab名 调它下面相应的方法
    currentTabChanged(name) {
      this.tabName = name;
      if (this.tabName == "database") {
        this.$refs.databaseChild.getAccountType();
        this.$refs.databaseChild.queryDatabaseEngines();
        this.$refs.databaseChild.queryDatabasesByApplicationId();
      } else if (this.tabName == "disk") {
        this.$refs.diskChild.queryVolumesByGroupId();
      } else if ((this, this.tabName == "Elasticsearch")) {
        this.$refs.ElasticsearchChild.queryElasticsearchByGroupId();
      }
    }
  }
};
</script>

<style scoped>
.ApplicationConfiguration-title {
  width: 100%;
  font-size: 13px;
  border-bottom: 2px solid #eaeceb;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 8px 4px;
  font-weight: 600;
}

.ivu-breadcrumb {
  font-size: 13px;
  font-weight: 600;
  color: #515a6e;
}
</style>



// WEBPACK FOOTER //
// src/components/ai_monitor/application_configuration/ApplicationConfiguration.vue